import { Fieldset as ChakraFieldset } from '@chakra-ui/react'

/**
 * Fieldset Component
 * Wrapped Chakra Fieldset with consistent Jira 2026 styling
 */
export function Fieldset({ children, ...props }) {
  return (
    <ChakraFieldset.Root
      border="1px solid"
      borderColor="#DFE1E6"
      borderRadius="md"
      p={4}
      {...props}
    >
      {children}
    </ChakraFieldset.Root>
  )
}

// Re-export Chakra Fieldset sub-components for convenience
Fieldset.Legend = ChakraFieldset.Legend
Fieldset.Content = ChakraFieldset.Content
Fieldset.HelperText = ChakraFieldset.HelperText
Fieldset.ErrorText = ChakraFieldset.ErrorText

export default Fieldset
